/* eslint-disable jsx-a11y/anchor-is-valid */
import { Dialog } from "@mui/material";
import { Field, Form, Formik } from "formik";
import { XIcon } from "lucide-react";
import * as yup from "yup";

import { normalizeCellphone, normalizeCEP } from "../../utils/inputMasks";
import CustomButton from "../button/CustomButton";
import { TextInput } from "../input/TextInput";

const validationSchema = yup.object({
  name: yup.string().required("Campo obrigatório"),
  email: yup.string().email("E-mail inválido").required("Campo obrigatório"),
  phone: yup.string().required("Campo obrigatório"),
  cep: yup.string().required("Campo obrigatório"),
});

export default function ModalCadastro({ open = false, setOpen }) {
  return (
    <Dialog
      onClose={() => setOpen(false)}
      open={open}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "20px",
          position: "relative",
          width: "100%",
          maxWidth: "37rem",
        },
      }}
    >
      <Formik
        onSubmit={async (values) => {
          setOpen(false);
        }}
        initialValues={{
          name: "",
          email: "",
          phone: "",
          cep: "",
        }}
        validationSchema={validationSchema}
      >
        {(formik) => (
          <Form>
            <div className="px-9 py-9 pt-7 space-y-6">
              <button
                type="button"
                className="flex justify-end items-center hover:opacity-50 transition-all duration-150 ease-linear absolute right-5 top-5"
                aria-label="Fechar modal"
              >
                <span onClick={() => setOpen(false)}>
                  <XIcon size={24} />
                </span>
              </button>
              <div className="w-full space-y-3 text-center mb-5">
                <div className="italic text-center text-neutral-900 text-[44px] font-medium font-['Roboto'] leading-[52.80px]">
                  Economize agora
                </div>
                <div className="text-center text-neutral-600 text-xl font-normal font-['Roboto'] leading-[30px]">
                  Preencha os campos e economize na sua conta.
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <Field
                    component={TextInput}
                    name="name"
                    label="Nome: *"
                    placeholder="Digite seu nome"
                    onChange={formik.handleChange}
                    hideBorderGreen
                  />
                </div>
                <div>
                  <Field
                    component={TextInput}
                    name="phone"
                    label="Telefone: *"
                    placeholder="(00) 00000-0000"
                    onChange={(e) => {
                      formik.setFieldValue(
                        "phone",
                        normalizeCellphone(e.target.value)
                      );
                    }}
                    value={normalizeCellphone(formik.values.phone)}
                    hideBorderGreen
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <Field
                    component={TextInput}
                    name="email"
                    label="E-mail: *"
                    placeholder="Digite seu e-mail"
                    onChange={formik.handleChange}
                    hideBorderGreen
                  />
                </div>
                <div>
                  <Field
                    component={TextInput}
                    name="cep"
                    label="CEP: *"
                    placeholder="00000-000"
                    onChange={(e) => {
                      formik.setFieldValue("cep", normalizeCEP(e.target.value));
                    }}
                    value={normalizeCEP(formik.values.cep)}
                    hideBorderGreen
                  />
                </div>
              </div>
              <div className="modal-forgot-cep">
                <a
                  href="http://www.buscacep.correios.com.br/sistemas/buscacep/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "underline" }}
                  aria-label="Não sei meu CEP"
                >
                  Não sei meu CEP
                </a>
              </div>
              <div className="modal-division-terms">
                <input className="messageCheckbox" type="checkbox" />
                <div className="modal-text-politics">
                  <span>
                    Estou ciente que ao finalizar o processo digital de
                    confirmação e compartilhamento de dados eu estou acordando
                    com os{" "}
                  </span>
                  <a href="#" aria-label="termos e politica de privacidade">
                    termos e politica de privacidade
                  </a>
                </div>
              </div>
              <CustomButton
                textButton="Adquira agora"
                blueVariant
                onClick={() => formik.handleSubmit()}
              />
            </div>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}
